module.exports = __webpack_public_path__ + "images/emoji/euro.426bcbbde7bec62c9cbf.png";